import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IListPartProps } from "./IListPartProps";

export const ListPartProperties = [
    { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useListPartProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IListPartProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IListPartProps = {
            title: bindings.getValue(Property.Tooltip),
            pageLink: bindings.getValue(Property.PageLink)
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
